module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_photogallery_1.c45c55f7.jpg";